import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const tableOption = function (that) {
  const validatePass = (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== that.account.password) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };

  const validateName = (rule, value, callback) => {
    var reg = new RegExp("^[a-zA-Z][0-9a-zA-Z_]+$");
    if (!reg.test(value)) {
      callback(new Error("名称由数字、字母、下划线组成，且首字符为字母"));
    } else {
      callback();
    }
  };

  const validatePwd = (rule, value, callback) => {
    var reg = new RegExp(
      "^(((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^\\s0-9a-zA-Z])|(?=.*[a-zA-Z])(?=.*[^\\s0-9a-zA-Z]))[^\\s]+)$"
    );
    if (!reg.test(value)) {
      callback(new Error("密码格式不正确"));
    } else {
      callback();
    }
  };

  const validatePhone = (rule, value, callback) => {
    var reg = new RegExp("^1[3456789]\\d{9}$");
    if (!reg.test(value)) {
      callback(new Error("手机号码格式不正确"));
    } else {
      callback();
    }
  };

  const validateEmails = (rule, value, callback) => {
    // var reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$')
    var reg = new RegExp(
      "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
    );
    if (!reg.test(value)) {
      callback(new Error("邮箱格式不正确"));
    } else if (value.indexOf("@") > 18 || value.indexOf("@") < 4) {
      callback(new Error("邮箱前缀为 4 到 18 个字符"));
    } else {
      callback();
    }
  };

  return {
    add: "新增账户",
    edit: "修改账户",
    view: "账户详情",
    page: true,
    selection: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "98px",
    dialogWidth: "800px",
    viewDialogWidth: "700",
    emptyText: "暂无账户",
    column: [
      {
        label: "账户名称",
        prop: "accountNumber",
        editDisabled: true,
        slot: true,
        search: true,
        overHidden: true,
        // align: 'left',
        searchPlaceholder: "请输入账户名称",
        rules: [
          {
            required: true,
            message: "请输入账户名称",
            trigger: "blur"
          },
          {
            min: 4,
            max: 30,
            message: "长度在 4 到 30 个字符",
            trigger: "blur"
          },
          {
            validator: validateName,
            trigger: "blur"
          }
        ],
        minRows: 4,
        maxlength: 30,
        span: 12
      },
      {
        label: "姓名",
        prop: "nickName",
        formslot: true,
        addDisplay: true,
        editDisplay: true,
        // viewDisplay: false,
        overHidden: true,
        search: true,
        searchPlaceholder: "请输入姓名",
        span: 12,
        rules: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "change"
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在 1 到 50 个字符",
            trigger: "change"
          }
        ]
      },
      {
        label: "编号",
        prop: "personnelCode",
        hide: true
      },
      // {
      //   label: "类型",
      //   prop: "accountType",
      //   type: "select",
      //   formslot: true,
      //   addDisplay: true,
      //   editDisplay: true,
      //   editDisabled: true,
      //   // viewDisplay: false,
      //   overHidden: true,
      //   search: true,
      //   searchPlaceholder: "请选择",
      //   span: 12,
      //   value: 0,
      //   dicData: [
      //     {
      //       label: "保卫",
      //       value: "1"
      //     },
      //     {
      //       label: "员工",
      //       value: "2"
      //     }
      //   ],
      //   viewFormatter: (row, value) => {
      //     switch (Number(value)) {
      //       case 1:
      //         value = "保卫";
      //         break;
      //       case 2:
      //         value = "员工";
      //         break;
      //       default:
      //         break;
      //     }
      //     return value;
      //   },
      //   formatter: (row, value) => {
      //     switch (Number(value)) {
      //       case 1:
      //         value = "保卫";
      //         break;
      //       case 2:
      //         value = "员工";
      //         break;
      //       default:
      //         break;
      //     }
      //     return value;
      //   },
      //   rules: [
      //     {
      //       required: true,
      //       message: "请选择类型",
      //       trigger: "blur"
      //     }
      //   ]
      // },
      {
        label: "性别",
        prop: "sex",
        type: "select",
        // formslot: true,
        addDisplay: true,
        editDisplay: true,
        // viewDisplay: false,
        overHidden: true,
        search: false,
        searchPlaceholder: "请选择",
        span: 12,
        dicData: Dic.find("SENU092"),
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU092", value);
        },
        formatter: function (row, value) {
          return Dic.findByValue("SENU092", value);
        },
        rules: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur"
          }
        ]
      },
      {
        formslot: true,
        label: "密码",
        prop: "password",
        value: "",
        hide: true,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: false,
        rules: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          },
          {
            validator: validatePwd,
            trigger: "blur"
          }
        ]
      },
      {
        label: "确认密码",
        prop: "confirmPassword",
        type: "password",
        value: "",
        hide: true,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: false,
        rules: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur"
          },
          {
            validator: validatePass,
            trigger: "blur"
          }
        ],
        span: 12
      },
      {
        label: "手机号码",
        // align: 'center',
        prop: "phone",
        type: "text",
        value: "",
        // formslot: true,
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        viewFormatter: (row, value) => {
          if (null != value && value != undefined) {
            let pat = /(\d{3})\d*(\d{4})/;
            return value.replace(pat, "$1****$2");
          } else {
            return value;
          }
        },
        formatter: (row, value) => {
          if (null != value && value != undefined) {
            let pat = /(\d{3})\d*(\d{4})/;
            return value.replace(pat, "$1****$2");
          } else {
            return value;
          }
        },
        maxlength: 11,
        rules: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"]
          },
          {
            validator: validatePhone,
            trigger: ["blur", "change"]
          }
        ],
        span: 12
      },
      {
        label: "邮箱地址",
        prop: "email",
        type: "text",
        placeholder: "example@example.com",
        // formslot: true,
        // value: 'example@example.com',
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        viewDisplay: true,
        maxlength: 64,
        rules: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur"
          },
          {
            validator: validateEmails,
            trigger: "blur"
          }
        ],
        span: 12
      },
      {
        label: "所属园区",
        prop: "parkName",
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        addDisabled: false,
        editDisabled: true,
        viewDisabled: false
      },
      {
        label: "状态",
        prop: "status",
        search: true,
        addDisabled: true,
        // searchDefault: [],
        type: "select",
        // slot: true,
        addDisplay: false,
        viewDisplay: false,
        editDisplay: false,
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return "启用";
          } else if (Number(value) === 2) {
            return "禁用";
          } else if (Number(value) === 3) {
            return "锁定";
          }
          return "";
        },
        // searchPlaceholder: "请选择状态",
        dicData: [
          {
            label: "启用",
            value: 1
          },
          {
            label: "禁用",
            value: 2
          },
          {
            label: "锁定",
            value: 3
          }
        ],
        span: 12
        // rules: [
        //   {
        //     required: true,
        //     message: "请选择状态",
        //     trigger: "blur"
        //   }
        // ]
      },
      {
        label: "图片",
        prop: "fileCode",
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        span: 24,
        align: "center",
        rules: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur"
          }
        ]
      },
      {
        label: "备注",
        prop: "desc",
        span: 24,
        type: "textarea",
        hide: true,
        minRows: 3,
        maxlength: 200,
        overHidden: true,
        placeholder: "请输入备注信息",
        addDisplay: true
      },
      {
        label: "角色",
        prop: "role",
        span: 24,
        formslot: true,
        viewslot: true,
        showColumn: true,
        search: true,
        overHidden: true,
        minRows: 10,
        maxlength: 200,
        searchPlaceholder: "请输入角色名称",
        addDisplay: true,
        formatter: (row, value) => {
          return row.accountGroupList
            ? row.accountGroupList.map((r) => r.accountGroupName).join(",")
            : "";
        }
      },
      {
        label: "创建时间",
        prop: "createTime",
        type: "datetime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        overHidden: true,
        // format: 'yyyy-MM-dd hh:mm:ss',
        valueFormat: "timestamp",
        span: 13,
        // align: 'center',
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      }
    ]
  };
};
export default tableOption;
